import discussionService from '../services/discussion_service'

export default {
	data () {
		return {
			modalParams: {},
			activeModal: null,
			state: history.state || {}
		};
	},
	computed: {
		discussions: function() {
			return this.state.discussions || {};
		}
	},
	mounted: function() {
		this.initFlashMessages();
	},
	methods: {
		deactivateModal: function() {
			this.activeModal = null;
		},
		reportDiscussion: function(discussionId) {
			this.modalParams = {
				reportableId: discussionId,
				reportable: 'discussion_id',
				title: 'Report discussion',
				reasons: ['Spam', 'Violates Community Guidelines']
			};

			this.activeModal = 'report-modal';
		},
		reportPost: function(postId) {
			this.modalParams = {
				reportableId: postId,
				reportable: 'discussion_post_id',
				title: 'Report post',
				reasons: ['Spam', 'Violates Community Guidelines']
			};

			this.activeModal = 'report-modal';
		},
		deleteDiscussion: function(id, redirectPath) {
			this.modalParams = {
				deletable: 'discussion',
				redirectPath: redirectPath,
				deletePath: '/discussions/' + id
			};
			this.activeModal = 'delete-modal';
		},
		deletePost: function(id) {
			this.modalParams = {
				deletable: 'post',
				redirectPath: location.pathname,
				deletePath: '/discussion_posts/' + id,
				noContent: true
			};
			this.activeModal = 'delete-modal';
		},
		newPost: function() {
			this.$eventHub.$emit('editPost', 'new');
		},
		replyPost: function(postId) {
			this.$eventHub.$emit('editPost', 'new', postId);
		},
		editPost: function(postId) {
			this.$eventHub.$emit('editPost', postId);
		},
		showPost: function (postId) {
			discussionService.showPost(postId);
		},
		isRead: function(id, isNew) {
			return isNew && !this.discussions[id] ? 'new' : 'read';
		},
		markRead: function(id) {
			this.$set(this.discussions, id, true);
			this.state['discussions'] = this.discussions;
			history.replaceState(this.state, null);
		},
		inviteMembers: function () {
			this.activeModal = 'invite-member-modal';
		},
		loginModal: function () {
			if (!Grabcad.authenticated) {
				return window.$$loginEventHub.$emit('signInModalTrigger');

			}
		},
		initFlashMessages: function () {
			var vm = this;
			Grabcad.store.flash.forEach(function (item) {
				vm.$eventHub.$emit('addAlert', {
					type: item.type,
					message: item.message,
					timeout: item.timeout * 1000
				});
			});
		}
	}
}